import { Component, Prop, Vue } from 'vue-property-decorator';
import { SdSlideOver } from '..'; 
import CsvService from '@/Services/CsvService';
import i18n from '../../lang';
import { ToasterService } from '@/Services/ToasterService';
import ProcessesService from '@/Services/ProcessesService';
import { TurnsTypesTranslations } from '@/Domain/enum';
import { mapGetters } from 'vuex';

@Component({
    computed: {
        ...mapGetters('languagesStore', { availableLanguages: 'getTranslatableLanguages' })
    }
})
export default class TurnPreferencesUploadFile extends Vue {
    csvToUpload: any[] = [];
    file: any = null;
    showModalFieldEncoding: boolean = false;
    showModalError: boolean = false;
    urlDownloadCsv: string = '';
    submitted: boolean = false;
    turnPreferencesListSuccess: null | number = null;
    turnPreferencesListError: null | number = null;
    TurnsTypesTranslations = TurnsTypesTranslations;
    availableLanguages!: string[];
    vacanciesUploadSuccess: null | number = null;

    $refs!: {
        slideOver: SdSlideOver;
    };

    closeSlideOver() {
        this.$emit('closeSlideOver');
        this.$refs.slideOver.setOverflowAutoToBody();
    }

    openSlideOver() {
        this.$emit('openSlideOver');
        this.$refs.slideOver.setOverflowAutoToBody();
    }

    addFile(file: any) {
        file.fileName = file.name;
        file.allowRemove = true;
        this.csvToUpload.push(file);
        this.file = file;
    }
    removeFile() {
        this.file = null;
        this.csvToUpload = [];
    }  

    showFieldEncoding() {
        this.showModalFieldEncoding = true;
    }
    
    closeModalFieldEncoding() {
        this.showModalFieldEncoding = false;
    }

    closeModalError() {
        this.showModalError = false;
    }

    downloadCsvErrors() {
      CsvService.getCsvFromBase64(this.urlDownloadCsv, i18n.t('lang.shared.turnPreferencesListImportedWithErrors') as string);
    }  

    getImportTurnPreferencesListCsvTemplate() {
        ProcessesService.getCSVReferences();
    }    
    
    importCSVLoadTurnPreferencesList() {
        this.submitted = true;
        if (!this.file) {
          return;
        }
        ProcessesService.importReferencesOnCall(this.$route.params.id, this.createFormData()).then((response: any) => {
            this.vacanciesUploadSuccess = response.successCount;
            if (response.errorCsv) {
                this.turnPreferencesListError = response.errorCount;
                this.urlDownloadCsv = response.errorCsv;
                this.showModalError = true;
            } else {
                ToasterService.showSuccess(i18n.t('lang.toaster.successTurnPreferencesListLoad', { vacanciesUploadSuccess: this.vacanciesUploadSuccess}) as any);
                this.$emit('updatedTurnReferences');
                this.closeSlideOver();
            }

            this.$refs.slideOver.setOverflowAutoToBody();
        });
      }

      createFormData(): FormData {
        const formData = new FormData();
        formData.append('referencesCsv', this.file);
        return formData;
      }

}
